//api/Formulario/AlterarStatusAtendenteSetorial
export const formatterStatusSetorialIniciandoFrontToBack = (atendenteLogado, dadosRequerimento, novoStatus) => {
  return {
    setorId: dadosRequerimento?.setorId,
    atendenteId: atendenteLogado?.id,
    formularioId: dadosRequerimento?.id,
    statusId: novoStatus?.id,
    justificativa: 'Iniciando o atendimento',
  };
};
